<template>
  <div class="createOrder">
    <div class="createOrder_head">
            <span>
              喜乐 {{ data.site_name }} No.{{ data.id }}
            </span>
      <span class="iconfont icon-xiangyou-copy"></span>
    </div>
    <div class="createOrder_content">
      <div v-if="data.site_type == 1">
        <span>今日油价</span>
        <span class="warning">0# {{ data.price }}元</span>
        <span class="warning" v-if="data.oil_type=='B5#'">B5# {{ data.price_b5 }}元</span>
      </div>
      <div v-if="data.site_type == 1">
        <span>余额</span>
        <span class="warning">{{ money }}元</span>
      </div>
      <div v-if="data.site_type == 1">
        <span>可加油量</span>
        <span class="warning">0# {{ (money / data.price).toFixed(2) }}升</span>
        <span class="warning" v-if="data.oil_type=='B5#'">B5# {{ (money / data.price_b5).toFixed(2) }}升</span>
      </div>
      <div v-if="data.site_type == 2">
        <span>账户油量</span>
        <span class="warning">{{ account_oil }}升</span>
      </div>
      <div>
        <span>确认油品质</span>
        <span>0#</span>
      </div>
      <div>
                <span class="fl"><label><span>{{ couponSelected }}</span><select @change="getCouponSelected"
                                                                                 v-model="couponSelected"
                                                                                 class="select"><option
                    v-for="coupon in couponList" :value="coupon.id">{{ coupon.name }}</option></select></label></span>
        <span class="editor" v-show="couponSelected=='加油油量'" @input="change">
                    <input v-model="total_number" type="number" placeholder="请输入升数">&nbsp;
                    <span>升</span>
                </span>
        <span class="editor" v-show="couponSelected=='加油金额'">
                    <input v-model="total_money" type="number" placeholder="请输入金额">&nbsp;
                    <span>元</span>
                </span>
      </div>
      <div>
        <span>车牌号</span>
        <span class="license_plate">
                    <label><span>{{ car_num }}</span><select class="select_arr_right select_car" v-model="car_num"><option
                        v-for="coupon in car_arr" :value="coupon">{{ coupon }}</option></select></label>
          <!-- <input type="text" :value="car_num"> -->
                </span>
      </div>
    </div>
    <div class="selecPayType_content" v-show="selecPayType_show">
      <div class="way_">
        <span>请选择支付方式</span>
      </div>
      <div class="selected_">
        <mt-radio v-model="pay_type" :options="options">
        </mt-radio>
      </div>
    </div>
    <div class="bt" @click="submit">确定</div>
    <!-- 支付失败弹出框 -->
    <div v-show="failure_show" class="failure">
      <span class="X_text">X</span>
      <span>加油失败,请重新扫码</span>
      <span>
                <span>失败原因:</span>
                <span class="failure_text">{{ failure_text }}</span>
            </span>
      <span @click="failures" class="failure_bt">确定</span>
    </div>
    <!-- 加油点不匹配弹出框 -->
    <div v-show="noMatching_show" class="noMatching">
      <span class="X_text">X</span>
      <span>{{ noMatching_text }}</span>
      <span class="failure_bt" @click="nocarBt">确定</span>
    </div>
    <!-- 车牌未绑定，弹出提示框 -->
    <div v-show="nocar_num_show" class="nocar_num">
      <span class="nocar_num_text">车牌未绑定，请联系车队做司机车牌绑定操作</span>
      <span class="nocar_num_bt" @click="nocarBt">确认</span>
    </div>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";
import {Radio, Indicator, MessageBox} from 'mint-ui';
import Vue from "vue";
import querystring from "querystring";

Vue.component(Radio.name, Radio);
export default {
  name: 'createOrder',
  data() {
    return {
      data: {
        site_name: "",
        id: "",
        oilman_id: ""//油站id
      },
      car_num: "",
      batch: "",//批号,扫描app二维码要用到
      total_number: "",//数量
      money: "",//金额
      total_money: "",//金额
      token: "",
      car_arr: [],//存放司机车牌号的数组
      pay_type: "账户余额支付",
      options: [
        {
          label: '账户余额支付',
          value: '账户余额支付',
        },
        {
          label: '微信支付',
          value: '微信支付'
        },
        {
          label: '支付宝支付',
          value: '支付宝支付'
        }
      ],
      couponList: [
        {
          id: '加油油量',
          name: "加油油量"
        },
        {
          id: "加油金额",
          name: "加油金额"
        }
      ],
      couponSelected: "加油油量",
      Submit_true: false,//提交了就为true,避免重复提交
      selecPayType_show: false,//选择支付方式默认不显示
      failure_text: "",
      failure_show: false,
      noMatching_text: "",
      noMatching_show: false,
      account_oil: "",//账户油量
      mobile: "",
      nocar_num_show: false,
      appXm: {
        app_id: '',
        oilNumber: '',//最大可用加油升数
        oilName: '',//油品名称
        userPhone: '',//手机号
        truckNo: '',//车牌
        accountType: '',//账号类型
        uscCode: '',//车队信用代码
      },
    }
  },
  methods: {
    change(e) {
      if (e.target.value >= 1000) {
        common.toast("加油油量不能大于1000");
        e.target.value = '';
      }
    },
    nocarBt() {
      this.$router.push({name: 'index'});
    },
    submit() {
      if (this.Submit_true) {
        return;
      }
      //Indicator.open();
      this.Submit_true = true;
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          let querystring = require('querystring');
          this.$api.post('wx/User/getLocation',
              querystring.stringify({
                latitude: res.latitude,
                longitude: res.longitude,
                token: this.token,
                action: "create_order",
              })
          )
        }
      });
      let querystring = require('querystring');
      if (this.appXm.app_id == 'xiangmeng') {
        if (eval(this.total_number) > eval(this.appXm.oilNumber)) {
          this.Submit_true = false;
          //common.toast("加油油量大于最大可用加油量");
          MessageBox('错误', '加油油量大于最大可用加油量！');
          return;
        }
        this.$api.post('wx/putbox/createOrder',
            querystring.stringify({
              site_id: this.data.id,
              app_id: this.appXm.app_id,
              oilNumber: this.appXm.oilNumber,
              oilName: this.oilname,
              userPhone: this.appXm.userPhone,
              truckNo: this.appXm.truckNo,
              accountType: this.appXm.accountType,
              uscCode: this.appXm.uscCode,
              total_number: this.total_number,
            })
        ).then(data => {
          if (data.data.status == 1) {
            let order_id = data.data.data.id;
            this.$router.replace({path: '/orderDetail/' + order_id + '?app_id=xiangmeng'});
          } else {
            common.toast(data.data.msg);
            this.Submit_true = false;
          }
        })
        return;
      }

      this.$api.post('wx/User/payOrder',
          querystring.stringify({
            site_id: this.data.id,
            car_number: this.car_num,
            oil_name: "0#",
            total_number: this.total_number,
            token: this.token,
            batch: this.batch,
            latitude: this.latitude,
            longitude: this.longitude,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let order_id = data.data.data.order_id;
          this.$router.replace({path: '/orderDetail/' + order_id});
        } else {
          Indicator.close();
          this.failure_show = true;
          this.failure_text = data.data.msg;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    //当选择加油金额时,显示选择支付方式;
    getCouponSelected() {
      if (this.couponSelected == "加油金额") {
        this.selecPayType_show = true;
      } else {
        this.selecPayType_show = false;
      }
    },
    failures() {
      this.$router.replace("/");
    },
    //验证是否为合作加油点
    VerifyDriver(site_id) {
      let token = this.token;
      let mobile = this.mobile;
      let querystring = require('querystring');
      this.$api.post('wx/checkAccount',
          querystring.stringify({
            token,
            site_id,
            mobile
          })
      ).then(data => {
        if (data.data.status == 0) {
          this.noMatching_show = true;
          this.noMatching_text = data.data.msg;
        } else {
          this.noMatching_show = false;
        }
      }).catch((err) => {
        common.toast(err);
      })
    },
    //获取账户存油和车牌号
    GetCarNumAndAccounOil(oilman_id) {
      let querystring = require('querystring');
      this.$api.post("wx/index",
          querystring.stringify({
            token: this.token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let car_Obj = data.data.data.car_list;
          let account_list = data.data.data.account_list;
          //获取司机车牌号(可能有多个)
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
          for (var index in car_Obj) {
            this.car_arr.push(car_Obj[index]);
          }
          //获取该加油点账户油量
          for (var index in account_list) {
            if (account_list[index].oilman_id == oilman_id || account_list[index].parent_name == oilman_id) {
              this.account_oil = account_list[index].oil_store;
              this.money = account_list[index].money;
            }
            if (this.account_oil == "" && account_list[index].oilman_id == -1) {
              this.account_oil = account_list[index].oil_store;
              this.money = account_list[index].money;
            }
          }
        } else {
          this.$router.replace({name: 'login'});
        }
      })
    },
    //获取司机及油站信息;
    getData() {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');
      this.VerifyDriver(uid);
      this.$api.post('/wx/site',
          querystring.stringify({
            token: this.token,
            uid: uid
          })
      ).then(data => {
        if (!!data.data.data[0]) {
          this.data = data.data.data[0];
          let oilman_id = data.data.data[0].oilman_id;
          this.GetCarNumAndAccounOil(oilman_id);
        }
      })
    },
    getSite() {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');
      this.$api.post('/wx/site',
          querystring.stringify({
            token: this.token,
            uid: uid
          })
      ).then(data => {
        if (!!data.data.data[0]) {
          this.data.site_name = data.data.data[0].site_name
          this.data.id = data.data.data[0].id
          if (data.data.data[0].oil_type == 'B5#') {
            this.oilname_arr = ['0#', 'B5#'];
          }
        }
      })
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require('querystring');
      this.$api.post('/wx/getUrl',
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      })
    },
    getUuid(uuid) {
      let querystring = require('querystring');
      this.$api.post('/wx/uuid/login',
          querystring.stringify({
            uuid: uuid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          common.setlocalStorage("userInfo", JSON.stringify(data.data));
        } else {
          this.$router.push({name: 'login'})
        }
      });
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require('querystring');
      this.$api.post('/wx/checkOpenid',
          querystring.stringify({
            openid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          //绑定了手机号,获取用户信息
          common.setCookie("token", data.data.token, 365);
          common.setCookie("mobile", data.data.mobile, 365);
          this.login_bol = true;
          this.mobile = data.data.mobile;
          this.token = data.data.token;
          this.getData();
        } else {
          //没有绑定了手机号,去登录页绑定
          this.$router.push({
            name: 'login',
            query: {
              openid: openid
            }
          })
        }
      })
    },
  },
  mounted() {
    //如果有批号就获取批号
    this.batch = this.$router.currentRoute.query.batch;
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;

    //驮鸟uuid登录
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.getUuid(uuid);
    }

    this.appXm.app_id = this.$router.currentRoute.query.app_id;//平台标识

    if (this.appXm.app_id == 'xiangmeng') {
      this.appXm.oilNumber = this.$router.currentRoute.query.oilNumber;//最大可用加油升数
      this.appXm.oilName = this.$router.currentRoute.query.oilName;//油品名称
      this.appXm.userPhone = this.$router.currentRoute.query.userPhone;//手机号
      this.appXm.truckNo = this.$router.currentRoute.query.truckNo;//车牌
      this.appXm.accountType = this.$router.currentRoute.query.accountType;//账号类型
      this.appXm.uscCode = this.$router.currentRoute.query.uscCode;//车队信用代码
      this.car_num = this.appXm.truckNo;
      this.account_oil = this.appXm.oilNumber;
      this.getSite();
      return;
    }

    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getData();
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
      this.getData();
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.$router.replace({name: 'login'});
      //this.getOpenid();
    }
  },
  destroyed() {
    Indicator.close();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.createOrder {
  width: 100%;
  overflow: hidden;
  background: #f6f5f5;
  color: #666666;
}

.createOrder_head {
  width: 100%;
  height: 2rem;
  background: white;
  margin: .2rem 0;
  padding: 0 0.6rem;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.6rem;
}

.createOrder_content {
  width: 100%;
  height: 9.2rem;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.createOrder_content > div {
  height: 1.5rem;
  border-bottom: 1px solid #f1f1f1;
  padding: 0 30px;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.5rem;
}

.warning {
  font-size: 0.5rem;
  color: red;
}

.editor {
  display: -webkit-flex;
}

.editor > input {
  border: none;
  width: 35vw;
  text-align: right;
  color: #323333;
  font-size: 0.5rem;
  padding: 0.1rem 0 0 0;
}

.editor > span {
  display: -webkit-flex;
  align-items: center;
}

.editor > input::-webkit-input-placeholder {
  font-size: 0.5rem;
}

.license_plate {
  width: 35vw;
  height: 1.2rem;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  background: #0097fe;
  border-radius: 5px;
  color: white;
}


.license_plate > input {
  background: #0097fe;
  width: 100%;
  margin: 0;
  border: none;
  text-align: center;
  font-size: 0.5rem;
  color: white;
}

.createOrder .bt {
  width: 50vw;
  margin: 1.5rem auto;
  height: 1.3rem;
  padding: 0 0.5rem;
  background: #0097fe;
  border-radius: 5px;
  line-height: 1.3rem;
  font-size: 0.5rem;
  color: white;
}

.selecPayType_content {
  width: 70vw;
  height: 30vh;
  margin-top: 20px;
  padding: 0 30px 0 30px;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.selecPayType_content > .way_ {
  width: 70vw;
  height: 9vh;
  display: -webkit-flex;
  font-size: 0.5rem;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}

.selected_ {
  width: 70vw;
  height: 20vh;
}

.createOrder .mint-cell-title {
  text-align: left;
  height: 6vh;
  font-size: 0.5rem;
  line-height: 6vh;
}

.select {
  color: #666666;
  text-align: left;
  font-size: 0.5rem;
  margin-left: -8px;
  position: absolute;
  left: 30px;
  opacity: 0;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}

.failure {
  width: 60vw;
  height: 60vh;
  border: 1px solid #0097fe;
  background: white;
  left: 20vw;
  position: absolute;
  top: 20vh;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 0.5rem;
  justify-content: space-between;
}

.noMatching {
  width: 60vw;
  height: 50vh;
  border: 1px solid #0097fe;
  background: white;
  left: 20vw;
  position: absolute;
  top: 20vh;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 0.5rem;
  justify-content: center;
  padding: 0 10px;
}

.noMatching > span:nth-child(1) {
  font-size: 3rem;
  color: red;
}

.noMatching > span:nth-child(2) {
  font-size: 0.7rem;
  color: red;
}

.noMatching > span:nth-child(3) {
  margin-top: 8vh;
}

.failure_text {
  color: red;
}

.failure > .X_text {
  font-size: 5rem;
  color: red;
}

.failure_bt {
  width: 100%;
  background: #0097fe;
  height: 50px;
  line-height: 50px;
  color: white;
}

.select_car {
  color: #666666;
  text-align: left;
  font-size: .5rem;
  margin-left: -8px;
  position: absolute;
  opacity: 0;
}

.select_arr_right {
  left: 52vw;
}

.select_arr_right_gun {
  left: 85vw;
}

.select_arr_right_oilname {
  left: 75vw;
}

.createOrder > .nocar_num {
  width: 60vw;
  height: 40vh;
  border: 1px solid rgb(26, 184, 164);
  background: white;
  left: 20vw;
  position: absolute;
  top: 20vh;
  display: -webkit-flex;
  flex-direction: column;
  font-size: .8rem;
  justify-content: center;
  padding: 0;
}

.createOrder > .nocar_num > .nocar_num_text {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.5rem;
}

.createOrder > .nocar_num > .nocar_num_bt {
  width: 100%;
  background: #0097fe;
  height: 1.3rem;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/createOrder.vue